// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ActorType,
  ClientType,
  PresenceStatus,
} from "./types";


export default __t.row({
  presenceId: __t.u64().primaryKey().name("presence_id"),
  userIdentity: __t.identity().name("user_identity"),
  displayName: __t.string().name("display_name"),
  avatarColor: __t.string().name("avatar_color"),
  get actorType() {
    return ActorType.name("actor_type");
  },
  agentType: __t.option(__t.string()).name("agent_type"),
  get clientType() {
    return ClientType.name("client_type");
  },
  clientVersion: __t.string().name("client_version"),
  get status() {
    return PresenceStatus;
  },
  statusMessage: __t.option(__t.string()).name("status_message"),
  joinedAt: __t.timestamp().name("joined_at"),
  lastHeartbeat: __t.timestamp().name("last_heartbeat"),
  isConnected: __t.bool().name("is_connected"),
  activeSessionId: __t.option(__t.u64()).name("active_session_id"),
  associatedTwinId: __t.option(__t.string()).name("associated_twin_id"),
});
